<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="allDocStates !== null">
      <v-expansion-panel>
        <v-expansion-panel-content>
          <div slot="header">Advance Filter</div>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 lg3>
                    <v-select :items="allDocStates" label="Document State" v-model="filterData.docState" autocomplete
                              @input="doFiltering" clearable />
                  </v-flex>
                  <v-flex xs12 lg3>
                    <v-text-field label="Imposition Name" v-model="filterData.impositionName" @input="doFiltering"
                                  clearable />
                  </v-flex>
                  <v-flex xs12 lg3>
                    <v-text-field label="Batch No" v-model="filterData.batchno" @input="doFiltering"
                                  clearable />
                  </v-flex>
                  <v-flex xs12 lg3>
                    <v-text-field label="Employee Name" v-model="filterData.employeeName" @input="doFiltering"
                                  clearable />
                  </v-flex>
                  <v-flex xs12 lg3>
                    <v-select :items="paginationSizes" label="Item(s) per page"
                              :value="paginationSize"
                              @input="setPaginationSize" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-flex xs12 v-if="loaded">
      <div class="text-xs-center" v-if="pagination.totalPages > 1">
        <v-pagination :length="pagination.totalPages" v-model="page" @input="gotoPage"></v-pagination>
      </div>
      <template v-if="requests.length > 0">
        <v-list v-for="item in requests" :key="item.id">
          <router-link :to="{name: 'business-trip-request-detail', params: {id: item.id}}">
            <v-card>
              <v-card-text>
                {{item.imposition.impositionName}} ({{item.fromCity.value}} - {{item.toCity.value}})<br />
                <v-chip class="mx-0" small label :color="getdocstateColor(item.documentState)" text-color="white">
                  <strong>{{item.documentState}}</strong>
                </v-chip>
                {{item.batchNo}} |
                {{item.requestDate | moment('DD MMM YYYY')}}<br />
                <v-icon small class="mr-1">person</v-icon>{{item.employeeContent}}
              </v-card-text>
            </v-card>
          </router-link>
        </v-list>
      </template>
      <h2 class="text-lg-center" v-else>No Business Trip Request Yet</h2>
      <div class="text-xs-center" v-if="pagination.totalPages > 1">
        <v-pagination :length="pagination.totalPages" v-model="page" @input="gotoPage"></v-pagination>
      </div>
    </v-flex>
    <v-flex xs12 v-else>
      <h2>Loading...</h2>
    </v-flex>
  </v-layout>
</template>

<script>
import Vuex from 'vuex'
import _ from 'lodash'

const {mapActions} = Vuex.createNamespacedHelpers('BusinessTripRequest/Request')
const genericStore = Vuex.createNamespacedHelpers('Generic')

export default {
  name: 'business-trip-request',
  data () {
    return {
      title: 'Business Trip Request',
      actions: [
        { label: 'Add New',
          tooltip: 'Add New',
          icon: 'add',
          color: 'success',
          to: {name: 'business-trip-request-new'} },
        { label: 'Refresh', tooltip: 'Refresh', icon: 'refresh', handler: this.loadResources }
      ],
      pagination: {},
      loaded: false,
      page: 1,
      filterData: {
        docState: '',
        impositionName: '',
        employeeName: '',
        batchno: ''
      }
    }
  },
  computed: {
    requests () {
      if (typeof this.pagination.content !== 'undefined') {
        return this.pagination.content
      } else {
        return []
      }
    },
    ...genericStore.mapState({
      allDocStates: 'allDocStates'
    }),
    paginationSize () {
      return this.$store.getters.paginationSize
    },
    paginationSizes () {
      return this.$store.getters.paginationSizes
    }
  },
  methods: {
    ...mapActions({
      filter: 'filter'
    }),
    ...genericStore.mapActions({
      listAllDocStates: 'listAllDocStates'
    }),
    loadResources () {
      const self = this
      self.listAllDocStates({vueinstance: self}).then(res => {
        self.gotoPage(this.page)
      }).catch(err => self.$error(err))
    },
    _setupToolbar () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', this.actions)
    },
    getdocstateColor (val) {
      return val === 'DRAFTED' ? 'grey darken-4' : val === 'SUBMITTED' ? 'success' : val === 'APPROVED' ? 'primary' : val === 'REJECTED' ? 'error' : val === 'REVISION' ? 'yellow accent-4' : 'orange'
    },
    gotoPage (page) {
      this.page = page
      this._doFiltering()
    },
    _doFiltering: function () {
      const self = this
      self.loaded = false
      self.filter({
        vueinstance: self,
        page: self.page - 1,
        ds: self.filterData.docState,
        impokey: self.filterData.impositionName,
        empkey: self.filterData.employeeName,
        batchno: self.filterData.batchno,
        size: self.paginationSize
      }).then(res => {
        // retry filtering when current page is past total pages
        if (self.page > res.totalPages && res.totalPages > 0) {
          self.page = 1
          self._doFiltering()
        } else {
          self.pagination = res
          self.loaded = true
        }
      }).catch(err => self.$error(err))
    },
    doFiltering: _.debounce(function () { this._doFiltering() }, 500),
    setPaginationSize (value) {
      this.$store.dispatch('setPaginationSize', {size: value, func: this.doFiltering})
    }
  },
  mounted () {
    if (this.$route.params.filter === 1) {
      this.filterData.docState = 'DRAFTED'
    } else if (this.$route.params.filter === 2) {
      this.filterData.docState = 'SUBMITTED'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm._setupToolbar()
      vm.loadResources()
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequest.vue